// @view/panels/document/PromptPage.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import PromptComponent from "@view/document/Prompt";
import type { DocumentPromptViewProps } from "@ps-bridge/contracts/documentPrompt";

export type PromptPagePhase = "missing" | "ready";

type PromptPagePanelProps = {
  phase: PromptPagePhase;
  viewProps: DocumentPromptViewProps;
};

const PromptPagePanel: React.FC<PromptPagePanelProps> = ({ phase, viewProps }) => {
  const render = {
    missing: <EmptyView />,
    ready: <PromptComponent {...viewProps} />,
  } as const satisfies Record<PromptPagePhase, React.ReactElement>;

  return (
    <div data-testid="page-prompt" data-page-state="ready" data-page-phase={phase}>
      {render[phase]}
    </div>
  );
};

export default PromptPagePanel;
